namespace GeniuzPOS.PosShift {
    export namespace PsVatRefundService {
        export const baseUrl = 'PosShift/PsVatRefund';

        export declare function Create(request: Serenity.SaveRequest<PsVatRefundRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsVatRefundRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsVatRefund/Create",
            Update = "PosShift/PsVatRefund/Update",
            Delete = "PosShift/PsVatRefund/Delete",
            Retrieve = "PosShift/PsVatRefund/Retrieve",
            GetNextNumber = "PosShift/PsVatRefund/GetNextNumber",
            List = "PosShift/PsVatRefund/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetNextNumber', 
            'List'
        ].forEach(x => {
            (<any>PsVatRefundService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
